import React, { useContext, useState, useEffect, useRef } from 'react'

import Layout from '@/product/components/templates/Layout'
import CustomTable from '@/product/components/molecules/CustomTable'
import CustomSearch from '@/product/components/molecules/CustomSearch'

import { useFormik } from 'formik'

import SettingContext from '@/product/context/setting/settingContext'

const CustomerActivity = () => {
    const settingcontext = useContext(SettingContext)
    const today = new Date()
    const currentYear = today.getFullYear()
    const {
        searchTableFetch,
        search_fetch_data,
        responseStatus: responseStatusSetting,
        clearResponse: clearResponseCommuncation,
    } = settingcontext

    const [changeStatus, setChangeStatus] = useState(false)
    const changeChangeStatus = () => {
        setChangeStatus(!changeStatus)
    }

    const [manage, setManage] = React.useState({
        popup: false,
        status: 'new',
        id: 0,
    })

    const [isLoading, setIsLoading] = useState(false)
    const [tableBody, setTableBody] = useState([])
    const [allData, setAllData] = useState({})

    const formikFetch = useFormik({
        initialValues: {
            page: 1,
            limit: 20,
            order: 'desc',
            orderby: 'bj.id',
            primaryTable: 'buyer_journey',
            timeConditionField: 'bj.created_at',
            search: 'within',
            // report: 'active_user_management',
            within: 'month',
            start_date: `01-01-${currentYear}`,
            end_date: `12-31-${currentYear}`,

            select_type: 'yearly',
            year: currentYear,
            tableJoins: [
                {
                    baseTable: 'users',
                    joinType: 'left',
                    baseJoinField: 'id',
                    connectJoinField: 'user_id',
                },
            ],
            filters: {
                // user_id: {
                //     type: 'in',
                //     value: '',
                //     field: 'bj.user_id',
                // },
                journey: {
                    type: 'notnull',
                    value: '',
                    field: 'bj.description',
                },
                user_name: {
                    type: 'like',
                    value: '',
                    field: 'u.first_name,u.last_name',
                },
                user_location: {
                    type: 'like',
                    value: '',
                    field: 'bj.user_location',
                },
            },
        },
        onSubmit: (values) => {
            searchTableFetch(values, 'buyer_journey')
            setIsLoading(true)
        },
    })
    useEffect(() => {
        setTableBody([])
        setIsLoading(true)
        // formikFetch.values.filters.active.value = '2'
        // formikFetch.values.page = 1
        // formikFetch.values.filters.description.value = ''
        searchTableFetch(formikFetch.values, 'buyer_journey')
    }, [])

    useEffect(() => {
        if (search_fetch_data) {
            if (search_fetch_data.from === 'buyer_journey') {
                setTableBody(
                    search_fetch_data.records.length
                        ? search_fetch_data.records
                        : []
                )

                setIsLoading(false)
            }
        }
    }, [search_fetch_data])

    const tableValues = [
        {
            field: 'users_first_name,users_last_name',
            type: '',
            firstChild: true,
            sort: true,
            disablePadding: false,
            label: 'User Name',
            filterable: true,
            filterField: 'u.first_name',
        },
        {
            field: 'users_email',
            type: '',
            firstChild: true,
            sort: false,
            disablePadding: false,
            label: 'User Email',
            // filterable: true,
            // filterField: 'u.first_name',
        },
        {
            field: 'created_at',
            type: 'datetime',
            firstChild: true,
            // sort: true,
            // filterField: 'bj.created_at',
            disablePadding: false,
            label: 'Created At',
        },
        // {
        //     field: 'api_url',
        //     type: '',
        //     firstChild: true,
        //     sort: false,
        //     //    filterField: 'bj.created_at',
        //     disablePadding: false,
        //     label: 'Buyer Journey',
        // },
        {
            field: 'description',
            type: '',
            firstChild: true,
            sort: false,
            filterField: '',
            disablePadding: true,
            label: 'Description',
        },
        {
            field: 'ip_address',
            type: '',
            firstChild: true,
            sort: false,
            filterField: '',
            disablePadding: false,
            label: 'IP Address',
        },
        {
            field: 'device_name',
            type: '',
            firstChild: true,
            sort: false,
            filterField: '',
            disablePadding: false,
            label: 'OS',
        },
        {
            field: 'browser_name',
            type: '',
            firstChild: true,
            sort: false,
            filterField: '',
            disablePadding: false,
            label: 'Browser',
        },
        {
            field: 'user_location',
            type: '',
            firstChild: true,
            sort: false,
            filterField: '',
            disablePadding: false,
            label: 'City',
        },
    ]

    const tableActions = []

    const searchInfo = {
        formik: formikFetch,
        data: [
            {
                label: 'User Name',
                placeholder: 'Enter User Name',
                class: 'col-md-4 col-sm-6 col-12',
                type: 'text',
                name: 'user_name',
                filter: true,
            },
            {
                label: 'City',
                placeholder: 'Enter City',
                class: 'col-md-4 col-sm-6 col-12',
                type: 'text',
                name: 'user_location',
                filter: true,
            },
        ],
    }

    return (
        <Layout>
            <div className="dashboard staticPages">
                <CustomSearch
                    incudeTimelineFilter={true}
                    searchInfo={searchInfo}
                    formik={formikFetch}
                />
                <div className="d-flex justify-content-between align-items-center mt-4"></div>

                <CustomTable
                    formik={formikFetch.values}
                    tableBody={tableBody}
                    tableValues={tableValues}
                    tableActions={tableActions}
                    allData={search_fetch_data}
                    isLoading={isLoading}
                    loadingTemplate={'table'}
                    changeTableFunction={searchTableFetch}
                    fromVariable={'buyer_journey'}
                />
            </div>
        </Layout>
    )
}
export default CustomerActivity
